import React, { Component } from 'react';

import {
    Button,
    Confirm,
    Header,
    Icon,
    Input,
    Label,
    Menu,
    Modal,
    Message,
    Segment,
    Select,
     } from "semantic-ui-react";

import { API } from 'aws-amplify';
import uuidv4 from "uuid/v4";
import ReactTable from "react-table";
import "react-table/react-table.css";


class Fee extends Component {

    constructor(props) {
      super(props);

      // Populate the state with initial empty data for rending
      this.state = {
          fees: [ { ranges: [] }],
          loading: false,
          showDeleteConfirm: false,
          showHelpMessage: false,
          showNewFeeDialog: false,
          showNewRangeDialog: false,
          showDeleteRangeConfirm: false,
          selectedFeeIndex: 0
      };
    }

    // Functions to control the display of dialogs and messages
    showDeleteConfirm = () => this.setState({ showDeleteConfirm: true })
    hideDeleteConfirm = () => this.setState({ showDeleteConfirm: false })
    showNewFeeDialog = () => this.setState({ showNewFeeDialog: true, newFee: {} })
    hideNewFeeDialog = () => this.setState({ showNewFeeDialog: false })
    showNewRangeDialog = () => this.setState({ showNewRangeDialog: true, newRange: {} })
    hideNewRangeDialog = () => this.setState({ showNewRangeDialog: false })
    showDeleteRangeConfirm = () => this.setState({ showDeleteRangeConfirm: true })
    hideDeleteRangeConfirm = () => this.setState({ showDeleteRangeConfirm: false })
    showHelpMessage = () => this.setState({ showHelpMessage: true })
    hideHelpMessage = () => this.setState({ showHelpMessage: false })

    // Retrieve all the fees from the backend
    getFees = async () => {
        try {
            this.setState({ loading: true });
            let response = await API.get('countrycost', '/fees');
            response.fees.forEach(fee => {
                fee.ranges.sort((a, b) => parseInt(a.limit) - parseInt(b.limit));
            });
            this.setState({ 
                fees: response.fees,
                selectedFeeIndex: 0 // Select the first fee in the Fees drop down
            }, () => console.debug("Fees", this.state.fees));
        } catch (error) {
            console.error('An error occurred retrieving fees', error);
        } finally {
            this.setState({ loading: false });
        }
    }

    // Push all the fees to the backend.
    saveFees = async () => {
        try {
            this.setState({ loading: true });

            // There are < 10 fees, send requests sequentially.
            for (let i = 0; i < this.state.fees.length; i++) {
                await API.post('countrycost', '/fees', { body: this.state.fees[i] });
            }
        } catch (error) {
            console.error('An error occurred retrieving fees', error);
        } finally {
            // Get any updates made by other clients.
            this.getFees();
        }
    }

    // Create the new fee locally only. When the ranges have been added the user can invoke saveFees()
    createNewFee = () => {
        try {
            this.setState(prevState => {
                prevState.showNewFeeDialog = false
                let count = prevState.fees.push(Object.assign(prevState.newFee, { id: uuidv4(), ranges: [] }));

                // Select the new fee in the Fees drop down
                prevState.selectedFeeIndex = count - 1;
                return prevState;
            });
        } catch (error) {
            console.error('An error occurred saving new fee', error);
        }
    }

    deleteFee = async () => {
        try {
            this.setState({ loading: true, showDeleteConfirm: false });
            await API.del('countrycost', '/fees/object/' + this.getSelectedFee().id);
            
        } catch (error) {
            console.error('An error occurred deleting fee', error);
        } finally {
            // Get any updates made by other clients.
            this.getFees();
        }
    }

    // Locally store the value entered for the new fee name until it is added to the Fee.
    handleNewName = (e, data) => this.setState(prevState => ({ newFee: {...prevState.newFee, name: data.value }}));

    // Tracks which fee is selected in the drop down
    changeSelectedFee = (e, data) => this.setState( { selectedFeeIndex: data.value } );

    // Convenience function to get the Fee object that is currently selected.
    getSelectedFee = () => this.state.fees[this.state.selectedFeeIndex];

    // Locally store a value entered for the new range until its added to the Fee.
    handleNewRangeValue = (e, data) => {
        // {name: 'limit', value '10000'} or {name: 'percent', value 5}
        this.setState(prevState => {
            prevState.newRange[data.name] = data.value;
            return prevState;
        });
    }


    // Adds 'newRange' to the currently selected fee's ranges array in local state.
    addNewRange = () => {
        this.setState(prevState => {
            let selectedFee = prevState.fees[prevState.selectedFeeIndex];
            selectedFee.ranges.push(prevState.newRange);
            selectedFee.ranges.sort((a, b) => parseInt(a.limit) - parseInt(b.limit));
            prevState.showNewRangeDialog = false;
            return prevState;
        });
    }

    // Deletes the selected fee range in the table from local state.
    deleteRange = () => {
        if (this.state.selectedRange === undefined) {
            alert('Please select a fee range in the table to delete.');
            return;
        }

        this.setState(prevState => {
            let selectedFee = prevState.fees[prevState.selectedFeeIndex];
            selectedFee.ranges.splice(this.state.selectedRange, 1);
            prevState.showDeleteRangeConfirm = false;
            return prevState;
        });
    }

    // Tracks which row in the table is selected
    onRowClicked = (state, rowInfo, column, instance) => {
        return {
            onClick: (e, handleOriginal) => {
                if (rowInfo !== undefined) {
                    this.setState({ selectedRange: rowInfo.index})
                }
                // React-Table uses onClick internally to trigger events.
                // By default a custom 'onClick' handler will override this functionality.
                // Fire the original onClick handler.
                if (handleOriginal) {
                  handleOriginal()
                }
            }
        }
    }

    renderEditable = (cellInfo) => {
        return (
          <div
            contentEditable
            suppressContentEditableWarning
            onBlur={e => {
                let cellValue = e.target.innerHTML;
                this.setState(prevState => {
                    let selectedRange = prevState.fees[prevState.selectedFeeIndex].ranges[cellInfo.index];

                    // Update the range's property value of the selected cell. Column id is 'limit' or 'percent'
                    selectedRange[cellInfo.column.id] = cellValue;
                    return prevState;
                });
            }}
            dangerouslySetInnerHTML={ { __html: Number(this.getSelectedFee().ranges[cellInfo.index][cellInfo.column.id]) } }
          />
        );
      }

    componentDidMount() {
        this.getFees();
    }


    render() {

        // The help message
        const DismissableMessage = (props) => {
            if (props.hidden) {
                return <Label as='a' content='Help' icon='help circle' onClick={this.showHelpMessage} />
            }

          return <Message info onDismiss={this.hideHelpMessage}
              header='Add, edit, and delete the professional fees that are included in building cost estimates.'
              list={[
                  'Choose which professional fee to manage by selecting it in the drop down list below.',
                  'The percentage applied for a professional fee in estimates is dependent on the cost of the build. The percentages to apply for each range of build cost is listed in the table below. The upper limit of the range is displayed in the first column. For example, if the first row contains an upper limit of 10,000 and a percentage of 5, and the second row contains an upper limit of 20,000 and a percentage of 2, a build cost of 9,000 will have 5% applied for the fee as it falls between 0 and 10,000. A build cost of 15,000 will have 2% applied for the fee as it falls between 10,001 and 20,000.',
                  'To add a new fee, click New and enter the fee name in the dialog, then click Add. Then enter the fee ranges in the table. When you have completed your changes click Save.',
                  'To delete a fee, select it in the drop down list and click Delete, then confirm or cancel the deletion when the confirmation dialog displays.',
                  'To add a new fee range, click Add Range. Enter the upper build cost limit and percentage, and click Add. Ensure that you do not add a limit that overlaps an existing one. Click Save when you have completed your changes.',
                  'To edit a fee range, modify the values in the table, then click Save when you have completed your changes.',
                  'To delete a fee range, select its row in the table, click Delete Range, and confirm or cancel the deletion when the confirmation dialog displays. Click Save when you have completed your changes.'
              ]} />
        }

        const feeOptions = this.state.fees.map((fee, index) => ({key: fee.id, value: index, text: fee.name}))

        return (
            <Segment>
                <DismissableMessage hidden={!this.state.showHelpMessage} />
                <Menu stackable>
                    <Menu.Item>
                        <Select value={this.state.selectedFeeIndex} options={feeOptions} onChange={this.changeSelectedFee}/>
                    </Menu.Item>
                    <Menu.Menu position='right'>
                        <Menu.Item>
                            <Button color='blue' onClick={this.showNewFeeDialog}>
                                <Icon name='pencil alternate' />New
                            </Button>

                            {/* Dialog to enter a new fee name */}
                            <Modal size='mini' open={this.state.showNewFeeDialog} >
                              <Header icon='pencil alternate' content='New Professional Fee' />
                              <Modal.Content>
                                <Input iconPosition='left' placeholder='Enter the fee name' fluid ={true} onChange={this.handleNewName}>
                                  <Icon name='tag' />
                                  <input />
                                </Input>
                              </Modal.Content>
                              <Modal.Actions>
                                <Button color='red' onClick={this.hideNewFeeDialog}>
                                  <Icon name='remove' /> Cancel
                                </Button>
                                <Button color='green' onClick={this.createNewFee}>
                                  <Icon name='checkmark' /> Add
                                </Button>
                              </Modal.Actions>
                            </Modal>

                        </Menu.Item>
                        <Menu.Item>
                            <Button color='green' onClick={this.saveFees}>
                                <Icon name='checkmark' /> Save
                            </Button>
                        </Menu.Item>
                        <Menu.Item>
                            <Button color='red' onClick={this.showDeleteConfirm}>
                                <Icon name='remove' /> Delete
                            </Button>

                            <Confirm
                                content={`Are you sure you want to delete fee ${this.getSelectedFee().name}?`}
                                open={this.state.showDeleteConfirm}
                                cancelButton='No'
                                confirmButton='Yes'
                                onCancel={this.hideDeleteConfirm}
                                onConfirm={this.deleteFee}
                            />

                        </Menu.Item>
                    </Menu.Menu>
                </Menu>
                <Segment loading={this.state.loading}>
                    <Header as='h4'>
                        <Icon name='percent' size='small'/>
                        <Header.Content>
                            Fee Percent Ranges
                        </Header.Content>
                    </Header>
                    <Menu stackable>
                        <Menu.Menu position='right'>
                            <Menu.Item>
                                <Button color='blue' onClick={this.showNewRangeDialog}>
                                    <Icon name='plus' />Add Range
                                </Button>

                                <Modal size='mini' open={this.state.showNewRangeDialog} >
                                  <Header icon='pencil alternate' content='New Fee Range' />
                                  <Modal.Content>
                                    <p>
                                      Enter the upper limit of the range, and the percentage to apply for build costs in the range.<br />
                                    </p>
                                    <Input name='limit' iconPosition='left' placeholder={'Range upper limit'}
                                            fluid={true} onChange={this.handleNewRangeValue}>
                                        <Icon name='arrow up' />
                                        <input />
                                    </Input>
                                    <br />
                                    <Input name='percent' iconPosition='left' placeholder={'Percent'}
                                            fluid ={true} onChange={this.handleNewRangeValue}>
                                      <Icon name='percent' />
                                      <input />
                                    </Input>
                                  </Modal.Content>
                                  <Modal.Actions>
                                    <Button color='red' onClick={this.hideNewRangeDialog}>
                                      <Icon name='remove' /> Cancel
                                    </Button>
                                    <Button color='green' onClick={this.addNewRange}>
                                      <Icon name='checkmark' /> Add
                                    </Button>
                                  </Modal.Actions>
                                </Modal>

                            </Menu.Item>
                            <Menu.Item>
                                <Button color='red' onClick={this.showDeleteRangeConfirm}>
                                    <Icon name='remove' /> Delete Range
                                </Button>

                                <Confirm
                                    content='Are you sure you want to delete the selected range?'
                                    open={this.state.showDeleteRangeConfirm}
                                    cancelButton='No'
                                    confirmButton='Yes'
                                    onCancel={this.hideDeleteRangeConfirm}
                                    onConfirm={this.deleteRange}
                                />

                            </Menu.Item>
                        </Menu.Menu>
                    </Menu>
                    <ReactTable
                        data={this.getSelectedFee().ranges }
                        noDataText="Please click 'Add Range' to add percentage ranges for the fee"
                        columns={[
                            {
                                Header: "Build Cost Upper Limit",
                                accessor: "limit",
                                sortMethod: (a, b) => {
                                    return parseInt(a) > parseInt(b) ? 1 : -1;
                                },
                                Cell: this.renderEditable,
                                minWidth: 150,
                                style: {textAlign: "right"}
                            },
                            {
                                Header: "Percentage Charged",
                                accessor: "percent",
                                sortMethod: (a, b) => {
                                    return parseFloat(a) > parseFloat(b) ? 1 : -1;
                                },
                                Cell: this.renderEditable,
                                minWidth: 150,
                                style: {textAlign: "center"}
                            }
                        ]}
                        className="-striped -highlight"
                        sortable={true}
                        defaultSorted={[ { id: "limit" } ]}
                        defaultPageSize={10}
                        getTdProps={this.onRowClicked}
                    />
                </Segment>
            </Segment>
        );
    }

}


export default Fee;
